module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-114x114-ab98a3a3ceb5b913cb9524c1df989312.png";